import { useMutation } from "@tanstack/react-query";
import { api, unwrap } from "@/lib/api";
import type { ApiEnvelope, CramPlanRequest, CramPlanResponse } from "@/lib/api-types";

/**
 * POST /students/me/cram-plan (Phase 8) -- a student building their own
 * pre-exam cram plan. Same deterministic planner as the parent-side
 * board-exam cram builder, scoped to self on the backend.
 */
export function useMyCramPlan() {
  return useMutation({
    mutationFn: async (vars: CramPlanRequest) => {
      const res = await api.post<ApiEnvelope<CramPlanResponse>>("/students/me/cram-plan", vars);
      return unwrap(res.data);
    },
  });
}
